import gql from "graphql-tag";
import actionFormContainer from "./actionFormContainer";
import {cancelRemovePalletFromClientDispatch, successRemovePalletFromClientDispatch} from "../../../actions/ClientDispatchApiActions";

export default actionFormContainer({
  mutation: gql`
    mutation removePalletFromClientDispatch($data: ClientDispatchPalletInput!) {
      removePalletFromClientDispatch(input: $data) {
        errors { key message }
      }
    }
  `,
  resultField: "removePalletFromClientDispatch",
  buildData: (props) => ({clientDispatchId: props.clientDispatchId, palletId: props.palletId}),
  formProps: (props) => ({
    submitLabel: "Remove Pallet",
    message: `Remove pallet ${props.palletId} from this dispatch?`,
  }),
  success: successRemovePalletFromClientDispatch,
  cancel: cancelRemovePalletFromClientDispatch,
});
